<div class="app-container">
  <page-header [icon]="'far-user-cog'" [title]="'users'">
    <ng-container class="header-button">
      <btn
        [routerLink]="['/user']"
        [classes]="['btn-first', 'float-right']"
        [icon]="'far-plus'"
        [label]="'user.new'"
        [title]="'user.new' | translate"
        data-cy="create-user"
      ></btn>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form [filters]="filters" [entity]="'users'" (onSubmit)="filter()" (onClearClick)="clearFilters()" [isFilterInvisible]="true">
      <form-row-input
        [icon]="'fa-user'"
        [label]="'email'"
        (keydown.enter)="filter()"
        [(model)]="filters.email"
        data-cy="user-email-filter"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [storageKey]="storageKey"
      [loadingNextItems]="loading"
      [loadingItems]="reloading"
      [items]="users"
      [columns]="listingColumns"
      [totalItems]="totalItems"
      [currentPage]="currentPage"
      [endPage]="endPage"
      [(sortProp)]="filters.sortProp"
      [(sortDir)]="filters.sortDir"
      (reloadList)="filter(1)"
      (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
      (callAction)="callAction($event)"
    ></app-base-listing>
  </section>
</div>
